import { FC } from "react";
import { IconWrapper } from "../IconWrapper";
import { IconProps } from "../Icons.types";

const CaretRight: FC<IconProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="CaretRight"
      icon={
        <svg
          width="inherit"
          height="inherit"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#clip0_4239_16009)">
            <path
              d="M9.25146 6.41254L14.8389 12L9.25146 17.5875"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeMiterlimit="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_4239_16009">
              <rect
                width="15.9553"
                height="8.72765"
                fill="white"
                transform="translate(16.4089 4.02235) rotate(90)"
              />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default CaretRight;
